module.exports = {
  "dialog-trigger.title": "Suche anpassen",
  "filter.type.label": "Suche",
  "filter.type.pattern": "Muster",
  "filter.type.prefix": "Wortanfang",
  "filter.type.substring": "Teilwort",
  "select2.placeholder": "Suchbegriff eingeben",
  "select2.selectionTooBig": "Es darf maximal ein Wert ausgewählt werden.",
  "select2.selectionTooBig_plural": "Es dürfen maximal {{count}} Werte ausgewählt werden."
}